"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brunello": {
    "6ffb04c8": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "skipSearch": false
    }],
    "casa-collodri": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eea3d775": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "skipSearch": false
    }],
    "casa-roncaccio": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa9905fe": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "skipSearch": false
    }],
    "monte-perada": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f6c9ebc": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo-rossa": [{
      "hkey": "b6be82a2",
      "slug": "brunello",
      "name": "Brunello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;